/*
 * @Author       : dxy
 * @Date         : 2020-12-10 13:24:53
 * @LastEditors  : dxy
 * @LastEditTime : 2020-12-10 16:31:58
 * @Descripttion : 头部远程组件
 */
import { queryRemotePlugin } from '@/services/remoteHeaderPlugin';
import { Reducer, Effect } from '@/typings/connect.d';

export interface RemoteHeaderPluginType {
  url: string;
  icon?: string;
  title?: string;
  menuShowType?: string;
  usePopover?:boolean;
}

export interface RemoteHeaderPluginStateType {
  remoteHeaderPlugin: RemoteHeaderPluginType[];
}

export interface RemoteHeaderPluginModelType {
  namespace: string;
  state: RemoteHeaderPluginStateType;
  effects: {
    qryRemoteHeaderPlugin: Effect;
  };
  reducers: {
    save: Reducer<RemoteHeaderPluginStateType>;
  };
}

const RemoteHeaderPluginModel: RemoteHeaderPluginModelType = {
  namespace: 'remoteHeaderPlugin',

  state: {
    remoteHeaderPlugin: [],
  },

  effects: {
    *qryRemoteHeaderPlugin(_, { call, put }) {
      const data = yield call(queryRemotePlugin);
      yield put({
        type: 'save',
        payload: {
          remoteHeaderPlugin: data,
        },
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default RemoteHeaderPluginModel;
